<template>
  <div>
    <a-modal
      :visible="modalVisible"
      class="modal-main"
      :footer="null"
      :maskClosable="false"
      @cancel="handleCloseModal"
    >
      <h1 class="modal-title">Sign in</h1>

      <a-form layout="vertical" :model="formList" :rules="rules" ref="formList">
        <a-form-item required name="account">
          <LineInput
            class="input-item"
            v-model:value="formList.account"
            placeholder="Email Address"
          ></LineInput>
        </a-form-item>

        <a-form-item required name="password">
          <LineInput
            class="input-item"
            v-model:value="formList.password"
            placeholder="Password"
            :isPassword="true"
            :visibilityToggle="true"
            :maxLength="20"
          ></LineInput>
        </a-form-item>

        <div class="forget-password">
          <a-button type="link" @click="handleForgetPassword">
            Forget Password
          </a-button>
        </div>

        <div class="button" @click="handleSignIn">
          Sign in
        </div>
      </a-form>
    </a-modal>
    <ForgetPasswordModal
      ref="forgetPassword"
      @show-modal="showModal"
    ></ForgetPasswordModal>
  </div>
</template>

<script>
import LineInput from '@/components/LineInput'
import ForgetPasswordModal from '@/components/ForgetPasswordModal'
import { validateEmail } from '@/utils/validate'

export default {
  name: 'SignInModal',
  components: { LineInput, ForgetPasswordModal },
  data() {
    let validateAccount = async (rule, value) => {
      if (!value) {
        return Promise.reject('Login email is required')
      } else if (!validateEmail(value)) {
        return Promise.reject('Please enter the correct email format')
      } else {
        return Promise.resolve()
      }
    }
    let validatePassword = async (rule, value) => {
      if (!value) {
        return Promise.reject('Password email is required')
      } else {
        return Promise.resolve()
      }
    }

    return {
      modalVisible: false,
      formList: {
        account: '',
        password: '',
      },
      rules: {
        account: [{ validator: validateAccount, trigger: 'blur' }],
        passowrd: [{ validator: validatePassword, trigger: 'blur' }],
      },
    }
  },
  methods: {
    showModal() {
      this.modalVisible = true
    },
    handleForgetPassword() {
      this.$refs.forgetPassword.showModal()
      this.handleCloseModal()
    },
    handleSignIn() {
      this.$refs.formList.validate().then(() => {
        this.$store.dispatch('user/Login', this.formList).then(() => {
          this.handleCloseModal()
          this.$store.commit('user/SET_LOGINEMAIL', this.formList.account)
          this.$router.push({ path: '/account' })
          this.$message.success('Welcome!')
        })
      })
    },
    handleCloseModal() {
      this.modalVisible = false
      this.formList = {
        account: '',
        password: '',
      }
    },
  },
}
</script>

<style lang="scss">
.modal-main {
  .modal-title {
    color: #0080ff;
  }
  .ant-modal-content {
    padding: 50px;
  }
  .forget-password {
    width: 100%;
    text-align: right;
    margin-top: 10px;
  }
  .button {
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    color: #fff;
    border-radius: 3px;
    text-align: center;
    margin-top: 30px;
    background: linear-gradient(to left, #00b0ff, #007dff) right;
    background-size: 200%;
    box-shadow: 0px 10px 10px -7px #00b0ff;
    transition: 0.5s;
    user-select: none;

    &:hover {
      cursor: pointer;
      background-position: left;
    }
    &:active {
      background: linear-gradient(to left, #0066ff, #0066ff);
    }
  }

  .cancel-button {
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    color: #fff;
    border-radius: 3px;
    text-align: center;
    margin-top: 30px;
    background: linear-gradient(315deg, #d1d1d1 0%, #d1d1d1 100%);
    box-shadow: 0px 0px 40px 0px rgba(12, 5, 103, 0.04);
    transition: 0.5s;
    user-select: none;

    &:hover {
      cursor: pointer;
      background-position: left;
    }
    &:active {
      background: linear-gradient(to left, #0066ff, #0066ff);
    }
  }

  .input-item {
    margin-top: 10px;
  }
}
@media screen and (min-width: 320px) and (max-width: 750px) {
  .modal-main .ant-modal-content {
    padding: 0px;
  }
}
</style>
